import { render, staticRenderFns } from "./buckle.vue?vue&type=template&id=aeff9768&scoped=true&"
import script from "./buckle.vue?vue&type=script&lang=js&"
export * from "./buckle.vue?vue&type=script&lang=js&"
import style0 from "./buckle.vue?vue&type=style&index=0&id=aeff9768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeff9768",
  null
  
)

export default component.exports